import React, { useState, useEffect } from 'react';
import { loadModules } from '@esri/react-arcgis';
import Legend from './Legend';
import ReactDOM from 'react-dom';

const Point = (props) => {
    const [graphic, setGraphic] = useState(null);
    useEffect(() => {
        loadModules(['esri/Graphic']).then(([Graphic]) => {
            
            for (var s in props.sites) {
                const point = {
                    type: "point",
                    latitude: props.sites[s].latitude,
                    longitude: props.sites[s].longitude
                };
                var color;
                if (props.sites[s].userType === "1") {
                    color = [125, 146, 240, .7];
                } else if (props.sites[s].userType === "2") {
                    color = [222, 26, 26, .7];
                } else {
                    color = [169, 92, 144, .7];
                }
                const pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    size: "8px",
                    color: color
                };
                const graphic = new Graphic({
                    attributes: props.sites[s],
                    geometry: point,
                    symbol: pointSymbol
                });
                setGraphic(graphic);
                props.view.graphics.add(graphic);
                 
            }
            var node = document.createElement('div');
            props.view.ui.add(node, 'bottom-right');
            ReactDOM.render(<Legend />, node);
        }
           
        ).catch((err) => console.error(err));
        props.view.on('click', function (e) {
            props.view.hitTest(e).then(function (response) {
                if (response.results.length > 0 && response.results[0].graphic.attributes.channels) {
                    props.onChange(response.results[0].graphic.attributes.id, response.results[0].graphic.attributes.name, response.results[0].graphic.attributes);
                }
            })
        });
        //props.view.on('pointer-move', function (e) {
        //    props.view.hitTest(e).then(function (response) {
        //        if (response.results.length > 0) {
        //            var point = props.view.toMap(e);
        //            props.view.popup.open({
        //                title: "Counting Site",
        //                content: "<table class='table table-striped'><tr><th>Site Name</th><th>Channels</th></tr><tr><td>" + response.results[0].graphic.attributes.name + "</td><td>" + response.results[0].graphic.attributes.channels.length + "</td></table>",
        //                location: point
        //            });
        //        } else {
        //            props.view.popup.close();
        //        }
        //    });
        //})
        return function cleanup() {
            props.view.graphics.remove(graphic);
        }
    }, []);
    return null;
}
export default Point;


// WEBPACK FOOTER //
// ./src/components/Point.js